<template lang="html">
  <div class="">
    <p class="error">404 error</p>
  </div>
</template>

<script>
  export default {

  }
</script>

<style lang="css" scoped>
  .error {
    font-size: 2.5rem;
    text-align: center;
  }
</style>
